/* eslint-disable ember/no-computed-properties-in-native-classes */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import { filter, alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import ReceiptFormat from '@linc-technologies/linced-common/enums/receipt-format';
import TransactionType from '@linc-technologies/linced-common/enums/transaction-type';

export default class DonationsController extends Controller {
  @service
  session;

  @service
  print;

  @service
  tax;

  @service
  toaster;

  TransactionType = TransactionType;

  @computed('session.school.jurisdiction')
  get buttonPhrasing() {
    return this.session.school.jurisdiction === Jurisdiction.AU_NSW
      ? 'Deductible Gift Receipt'
      : 'Tax Receipt';
  }

  @filter('model.transactions', function (transaction) {
    return (
      !isEmpty(transaction.line_item_id) &&
      transaction.type !== TransactionType.ADJUSTMENT
    );
  })
  transactions;

  @filter('model.transactions', function (transaction) {
    return (
      !isEmpty(transaction.line_item_id) &&
      !isEmpty(transaction.get('account.person_id')) &&
      [
        TransactionType.APPORTIONMENT,
        TransactionType.TRANSFER,
        TransactionType.REFUND,
      ].includes(transaction.type)
    );
  })
  receiptTransactions;

  @computed('receiptTransactions.@each.date')
  get transactionDates() {
    return [
      ...new Set(
        this.receiptTransactions
          .slice()
          .sort((a, b) => (a.date || '').localeCompare(b.date || ''))
          .map((t) => t.date),
      ),
    ];
  }

  @alias('transactionDates.firstObject')
  minDate;

  @alias('transactionDates.lastObject')
  maxDate;

  @computed('minDate', 'maxDate')
  get taxYears() {
    return this.tax.getTaxYears(this.minDate, this.maxDate);
  }

  @tracked
  receiptGenerating = false;

  @action
  receipt(taxYear) {
    this.receiptGenerating = true;
    let transactions = this.receiptTransactions.filter((transaction) => {
      return (
        transaction.date >= taxYear.start && transaction.date <= taxYear.end
      );
    });
    this.print.donationReceipt(
      transactions,
      this.model.accounts,
      taxYear,
      this.session.get('school'),
      ReceiptFormat.STANDARD,
      (succeeded) => {
        if (succeeded) {
          this.toaster.success(`${taxYear.label} tax receipt generated`);
        } else {
          this.toaster.error(`Error generating ${taxYear.label} tax receipt`);
        }
        this.receiptGenerating = false;
      },
    );
  }
}
